<template>
  <div>
    <v-row
      justify=center
      class="main--text">
      <v-col>
        <v-card>
          <v-container
            fluid
            >
            <v-row
              no-gutters
              align=center
              justify=space-between>
              <v-col
                cols=auto
                class="student--name"
                @click="$emit('info-button-click')"
                >
                <h3>{{ student.fullName() }}</h3>
              </v-col>
              <v-col
                cols=auto>
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small
                      color="grey lighten-2"
                      @click="$emit('delete-button-click')">mdi-close-circle</v-icon>
                  </template>
                  登録を抹消する
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              >
              <v-col>
                <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          性別
                        </v-list-item-subtitle>
                        <v-list-item-title>
                          {{student.genderInJapanese()}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          学年
                        </v-list-item-subtitle>
                        <v-list-item-title>
                          {{student.grade().toJapanese()}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                </v-list>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col>
                <v-subheader>希望時間帯</v-subheader>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col
                cols=auto>
                <v-chip
                  small
                  outlined
                  text-color="black"
                  v-for="(schedule, index) in student.availableSchedulesToStrings()"
                  :key="index">{{schedule}}</v-chip>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    student: Object
  }
}
</script>

<style scoped>
.student--name {
  cursor: pointer;
}
.student--name:hover {
  opacity: 0.7;
  background-color: rgba(rgb(134, 134, 134), green, blue, .80)
}
</style>
